import config from "../config";
import request, { requestOptions } from "../utils/request";

const baseUrl = `${config.API_ROOT}/auth`;

const Auth = {
  async login(loginData: object) {
    const options = await requestOptions("POST", loginData, false);
    const url = `${baseUrl}/login`;
    return request(url, options);
  },

  async register(userData: object) {
    const options = await requestOptions(
      "POST",
      { ...userData, isFront: true },
      false,
    );
    const url = `${baseUrl}/register`;
    return request(url, options);
  },
  async registerUser(registerData: object) {
    const options = await requestOptions("POST", registerData, false);
    const url = `${baseUrl}/register-user`;
    return request(url, options);
  },
  async getRegisterUserInfoToken(token: string) {
    const options = await requestOptions("POST", { token }, false);
    const url = `${baseUrl}/register-user-token-info`;
    return request(url, options);
  },
  async approve(approveData: object) {
    const options = await requestOptions("POST", approveData, false);
    const url = `${baseUrl}/approve`;
    return request(url, options);
  },
  async me() {
    const options = await requestOptions("GET", {}, true);
    const url = `${baseUrl}/me`;
    return request(url, options);
  },
  async push(pushData: object) {
    const options = await requestOptions("POST", pushData, true);
    const url = `${baseUrl}/push`;
    return request(url, options);
  },
  async resetPush(pushData: object) {
    const options = await requestOptions("POST", pushData, true);
    const url = `${baseUrl}/push-reset`;
    return request(url, options);
  },
  async language(language: object) {
    const options = await requestOptions("POST", language, true);
    const url = `${baseUrl}/language`;
    return request(url, options);
  },

  async forgotPassword(forgotData: object) {
    const options = await requestOptions("POST", forgotData, false);
    const url = `${baseUrl}/forgot-password`;
    return request(url, options);
  },
  async resetPassword(resetData: object) {
    const options = await requestOptions("POST", resetData, false);
    const url = `${baseUrl}/reset-password`;
    return request(url, options);
  },
  async logout(logOutData: object) {
    const options = await requestOptions("POST", logOutData, true);
    const url = `${baseUrl}/logout`;
    return request(url, options);
  },
  async switchCompany(companyData: object) {
    const options = await requestOptions("POST", companyData, true);
    const url = `${baseUrl}/switch-company`;
    return request(url, options);
  },
};

export default Auth;
